import * as React from 'react';

import type { ComposedOrganization } from 'bundles/internal-enterprise/types/Organization';
import type { ComposedProgramMembership } from 'bundles/internal-enterprise/types/ProgramMembership';
import Table from 'bundles/internal-ui/components/table/Table';

import 'css!./__styles__/EnterpriseToolsHome';

type Props = {
  organizations: Array<ComposedOrganization>;
  columns: Array<{
    key: string;
    name: string;
  }>;
  sortColumn: string;
  tableActions: Array<{
    icon: string;
    tooltip: string;
    onClick: (x0: ComposedProgramMembership) => void;
  }>;
};

class OrganizationPrograms extends React.Component<Props> {
  render() {
    const { organizations, sortColumn, columns, tableActions } = this.props;
    return (
      <div>
        {organizations.map((org) => (
          <div key={org.id}>
            <h4>{org.name}</h4>
            <p>
              {org.slug} | {org.id}
            </p>
            {org.contracts.map((contract: $TSFixMe) => (
              <div key={contract.id}>
                <p>
                  <strong>
                    Contract {contract.id}{' '}
                    {contract.limits.coursesPerUserLimit && `(Course limit: ${contract.limits.coursesPerUserLimit})`}
                  </strong>
                </p>
                <Table
                  rows={contract.memberships}
                  columns={columns}
                  initialSortColumn={sortColumn}
                  sortDescending={true}
                  actions={tableActions}
                  rowId={(data) => data.id}
                />
              </div>
            ))}
            <hr />
          </div>
        ))}
      </div>
    );
  }
}

export default OrganizationPrograms;
